export const data = {


    scene: '03_sauvat_matala_plus',
    kysymysteksti: 'Säädit sauvat hieman liian ylhäälle = pitkiksi - säädä vielä uudelleen.',

    optiot: []


};